import { useState } from 'react';
import { toast } from 'sonner';
import { RotateCcw } from 'lucide-react';
import { pmT } from '../../lib/i18nPm';
import { pmOf, posOf, posLabel } from '../../lib/pm';
import { decide } from '../../lib/pmPkg';

const side = (p, d, t) => (!d ? '–' : [d.title || d.name, d.text?.slice(0, 220), d.pm && posLabel(posOf(p, d.pm.posId)), d.pm?.team, d.pm?.at && new Date(d.pm.at).toLocaleString(t.locale), d.photos && `${d.photos.length} Fotos`].filter(Boolean));

function Conflict({ t, p, c, app }) {
  const T = pmT(), [why, setWhy] = useState('');
  const go = async (choice) => { if (!why.trim()) return toast.error(T.reason); await app.save(decide(p, c.id, choice, why.trim())); };
  return (
    <div className="pm-conflict" data-testid={`pm-conflict-${c.id}`}>
      <div className="pm-cmp">
        <div><b>{T.office}</b>{side(p, c.office, t).map((x) => <p key={x}>{x}</p>)}</div>
        <div><b>{T.field} · {c.team || '–'}</b>{side(p, c.field, t).map((x) => <p key={x}>{x}</p>)}</div>
      </div>
      <input className="pm-input" placeholder={T.reason} value={why} onChange={(e) => setWhy(e.target.value)} data-testid={`pm-conflict-reason-${c.id}`} />
      <div className="pm-actions">
        <button className="pm-btn pm-ghost" data-testid={`pm-conflict-office-${c.id}`} onClick={() => go('office')}>{T.keepO}</button>
        <button className="pm-btn pm-ghost" data-testid={`pm-conflict-field-${c.id}`} onClick={() => go('field')}>{T.takeF}</button>
        {c.type === 'report' && <button className="pm-btn pm-ghost" data-testid={`pm-conflict-both-${c.id}`} onClick={() => go('both')}>{T.both}</button>}
      </div>
    </div>
  );
}

// open conflicts (both values + origin, decision with reason) and waiting incoming items
export function PmConflicts({ t, p, app, onRetry }) {
  const T = pmT(), pm = pmOf(p), open = pm.conflicts.filter((c) => !c.decision), done = pm.conflicts.filter((c) => c.decision);
  if (!open.length && !pm.inbox.length && !done.length) return null;
  return (
    <div className="pm-card" data-testid="pm-conflicts">
      {open.length > 0 && <><h3>{T.confT} ({open.length})</h3>{open.map((c) => <Conflict key={`${c.id}-${c.at}`} t={t} p={p} c={c} app={app} />)}</>}
      {pm.inbox.length > 0 && <><h3>{T.inboxT} ({pm.inbox.length})</h3><ul className="pm-items">{pm.inbox.map((i) => <li key={i.id} data-testid={`pm-inbox-${i.id}`}><b>{i.data?.title || i.id}</b> <small className="pm-muted">– {T.why[i.why]} · {i.team || '–'}</small> <button className="pm-btn pm-ghost" data-testid={`pm-inbox-retry-${i.id}`} onClick={() => onRetry(i)}><RotateCcw size={13} /> {T.retry}</button></li>)}</ul></>}
      {done.length > 0 && <details><summary>{T.decided} ({done.length})</summary>{done.map((c) => <p key={`${c.id}-${c.decidedAt}`} className="pm-muted" data-testid={`pm-decided-${c.id}`}>{c.field?.title || c.id}: {{ office: T.keepO, field: T.takeF, both: T.both }[c.decision] || c.decision} – „{c.reason}“ · {new Date(c.decidedAt).toLocaleString(t.locale)}</p>)}</details>}
    </div>
  );
}
